export default __webpack_public_path__ + "ca58317284afee10355c835122bab18e.svg";